import { ApiModel } from './models/api.model';

export const API: ApiModel = {
  domains: {
    aus: 'https://development.workshopsoftware.com.au',
    can: 'https://development.workshopsoftware.com.au',
    gbr: 'https://development.workshopsoftware.com.au',
    usa: 'https://development.workshopsoftware.com.au'
  },
  subdomain: 'development',
  url      : SERVER_ENDPOINT || '/api'
};
